import React from 'react';
import { Pressable } from 'react-native';
import Animated, { useAnimatedStyle, interpolate, Extrapolation, } from 'react-native-reanimated';
import { withTheme } from '@rneui/themed';
import { FAIcon } from '../elements';
export const UnthemedPlayerHandle = ({ position, onTogglePlayer, handleStyle: handleTouchableStyle, handleIconStyle, }) => {
    const handleStyle = useAnimatedStyle(() => {
        const opacity = interpolate(position.value, [1, 0], [1, 0], Extrapolation.CLAMP);
        const leftIndicatorRotate = interpolate(position.value, [0, 1], [-90, 0], Extrapolation.CLAMP);
        return {
            opacity,
            alignSelf: 'flex-start',
            padding: 10,
            transform: [
                {
                    rotate: `${leftIndicatorRotate}deg`,
                },
            ],
        };
    });
    return (React.createElement(Pressable, { onPress: onTogglePlayer, style: handleTouchableStyle },
        React.createElement(Animated.View, { style: handleStyle },
            React.createElement(FAIcon, { name: 'chevron-down', ...handleIconStyle }))));
};
export const PlayerHandle = withTheme(UnthemedPlayerHandle, 'PlayerHandle');
//# sourceMappingURL=PlayerHandle.js.map